// native
import { Component, ChangeDetectionStrategy, NgZone, ElementRef, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// service
import { GlobalsService } from '../core/services/globals.service';
import { AuthService } from '../core/services/auth.service';

@Component({
  selector: 'scs-login',
  templateUrl: './login.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginComponent implements OnInit {

  constructor(
    private authService: AuthService,
    private globalsService: GlobalsService,
    private ngZone: NgZone,
    private elementRef: ElementRef
  ) { }

  isLoginProcessing$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  isTutorialProcessing$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  ngOnInit() {
    this.elementRef.nativeElement.addEventListener('mouseenter', () => {
      this.isLoginProcessing$.next(false);
    });
  }

  onLoginClick() {
    this.isLoginProcessing$.next(true);

    this.globalsService.appConfig.openLogin().then((token: string | null) => {
      // SC Word will send token, if no token(SC Docs) app will be refreshed inside Docs consumer app
      if (token) {
        this.ngZone.run(() => this.authService.login(token));
        return;
      }
    }).catch(err => {
      this.ngZone.run(() => this.isLoginProcessing$.next(false));
    });
  }

  onTutorialClick() {
    this.isTutorialProcessing$.next(true);
    this.globalsService.appConfig.openTutorial().then(() => {
      this.isTutorialProcessing$.next(false);
    }).catch(() => {
      this.isTutorialProcessing$.next(false);
    });
  }
}
